import LanguageSwitcher from './LanguageSwitcher'

export default LanguageSwitcher

export { LanguageSwitcher }
